import { render, staticRenderFns } from "./IconHeader.vue?vue&type=template&id=4c09f63c&scoped=true"
import script from "./IconHeader.vue?vue&type=script&lang=js"
export * from "./IconHeader.vue?vue&type=script&lang=js"
import style0 from "./IconHeader.vue?vue&type=style&index=0&id=4c09f63c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c09f63c",
  null
  
)

export default component.exports